/**
 * CSS line clamping polyfill, which polyfills
 * [data-ellipsis="text to clamp"] elements.
 */
import { nodes, addDocumentEvent, addWindowEvent } from '../../jsCore/utils/dom'
import { registerUtils } from '../application/nm'
import { supportedProperty } from 'css-vendor'
import { queryString } from './window'
import { info } from '../application/console'

const TRIGERRING_EVENTS = {
  DOCUMENT: ['DOMContentLoaded', 'load'],
  WINDOW: ['orientationchange', 'resize'],
}
const ELLIPSIZE_DATA_ATTR_NAME = 'ellipsis'
const UNKNOWN = null
const { debugEllipsis, forceEllipsis, forceNoEllipsis } = queryString

let isLineClampPolyfillEnabled = UNKNOWN

function shouldPolyfillLineClamp() {
  if (forceEllipsis) {
    return true
  }
  if (forceNoEllipsis) {
    return false
  }
  if (isLineClampPolyfillEnabled !== UNKNOWN) {
    return isLineClampPolyfillEnabled
  }
  isLineClampPolyfillEnabled = !supportedProperty('line-clamp')
  return isLineClampPolyfillEnabled
}

function isOverflowing(element) {
  return element.clientHeight > 0 && element.clientHeight < element.scrollHeight - 1
}

export function ellipsize(element) {
  if (!shouldPolyfillLineClamp()) {
    return element
  }
  const originalTextContent = element.dataset[ELLIPSIZE_DATA_ATTR_NAME].trim()
  const firstTextNode = Array.from(element.childNodes).find(
    child => child.nodeType === document.TEXT_NODE && child.textContent.trim().length
  )
  if (!firstTextNode) {
    return element
  }
  const textContent = firstTextNode.textContent.trim()
  if (textContent !== originalTextContent) {
    element.title = originalTextContent
    firstTextNode.textContent = originalTextContent
  }
  while (firstTextNode.length > 1 && isOverflowing(element)) {
    firstTextNode.textContent = firstTextNode.textContent.trim().replace(/..$/, '…')
  }
  return element
}
export { info }

export function ellipsizeAll(e) {
  if (debugEllipsis) {
    info(`[ellipsizeAll: ${e.type}]`, e)
  }
  if (!shouldPolyfillLineClamp()) {
    return []
  }
  const elements = Array.from(nodes(`[data-${ELLIPSIZE_DATA_ATTR_NAME}]`))
  return elements.map(ellipsize)
}

export function initializeEllipsis() {
  if (!shouldPolyfillLineClamp()) {
    return []
  }
  const { DOCUMENT, WINDOW } = TRIGERRING_EVENTS
  return [
    ...DOCUMENT.map(eventName => addDocumentEvent(eventName, ellipsizeAll)),
    ...WINDOW.map(eventName => addWindowEvent(eventName, ellipsizeAll)),
  ]
}

const ellipsis = { ellipsize, ellipsizeAll, initializeEllipsis }

registerUtils({ ellipsis })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/ellipsis.js